import axios from 'axios';

Shopify.functions.getCart = async function getCart() {
  try {
    const response = await axios.get('/cart.js');
    const cart = response.data;
    return cart;
  } catch (error) {
    console.error(error);
  }
};
